/**
 * Mobile horizontal inset (MUI spacing 1).
 * Use mobileContentInsetSx on card/list stacks.
 * Use tableContainerInsetSx on TableContainer (not both on parent + child).
 */

/** MUI spacing units for left/right inset on mobile. */
export const MOBILE_EDGE_INSET_SPACING = 1;

/** Card lists inside a scroll region. */
export const mobileContentInsetSx = {
  boxSizing: "border-box",
  pl: { xs: MOBILE_EDGE_INSET_SPACING, md: 0 },
  pr: { xs: MOBILE_EDGE_INSET_SPACING, md: 0 },
};

/** Vertical gap between stacked mobile cards. */
export const MOBILE_CARD_LIST_GAP = "1px";

/** Row gap only — use when horizontal inset comes from a parent scroll region. */
export const mobileCardListGapSx = {
  gap: MOBILE_CARD_LIST_GAP,
};

/** Inset + row gap for mobile card lists (use when parent has no horizontal inset). */
export const mobileCardListSx = {
  ...mobileContentInsetSx,
  ...mobileCardListGapSx,
};

/**
 * Toolbar / filter row above mobile card lists — same horizontal alignment as cards.
 * Pair with scrollRegionSx on the list scroll parent (one inset layer only).
 */
export const mobileCardToolbarInsetSx = {
  ...mobileContentInsetSx,
  boxSizing: "border-box",
  width: "100%",
  maxWidth: "100%",
};

/** TableContainer only — do not combine with mobileContentInsetSx on a parent scroll box. */
export const tableContainerInsetSx = {
  boxSizing: "border-box",
  pl: { xs: MOBILE_EDGE_INSET_SPACING, md: 0 },
  pr: { xs: MOBILE_EDGE_INSET_SPACING, md: 0 },
};
